function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#B7BCC3",
  fillRule: "evenodd",
  d: "M14.009 12l6.57-6.571a1.42 1.42 0 10-2.008-2.012L12 9.987l-6.571-6.57a1.422 1.422 0 10-2.012 2.012L9.987 12l-6.57 6.571a1.422 1.422 0 102.012 2.012L12 14.013l6.571 6.57a1.422 1.422 0 102.012-2.012L14.01 12z"
});

var SvgClose = function SvgClose(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8cGF0aCBmaWxsPSIjQjdCQ0MzIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4wMDkgMTJsNi41Ny02LjU3MWMuNTU2LS41NTUuNTU3LTEuNDU1LjAwMi0yLjAxLS41NTQtLjU1Ni0xLjQ1NC0uNTU3LTIuMDEtLjAwMkwxMiA5Ljk4N2wtNi41NzEtNi41N2MtLjU1Ni0uNTU2LTEuNDU3LS41NTYtMi4wMTIgMC0uNTU2LjU1NS0uNTU2IDEuNDU2IDAgMi4wMTJMOS45ODcgMTJsLTYuNTcgNi41NzFjLS41NTYuNTU2LS41NTYgMS40NTcgMCAyLjAxMi41NTUuNTU2IDEuNDU2LjU1NiAyLjAxMiAwTDEyIDE0LjAxM2w2LjU3MSA2LjU3Yy41NTYuNTU2IDEuNDU3LjU1NiAyLjAxMiAwIC41NTYtLjU1NS41NTYtMS40NTYgMC0yLjAxMkwxNC4wMSAxMnoiIC8+Cjwvc3ZnPgo=";
export { SvgClose as ReactComponent };